import React from "react";
import "../../App.css";
import { FaEye, FaEyeSlash, FaTimes } from "react-icons/fa";
import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";
import SkyLoader from "../../components/sky-loader";
import { useLoginLogic } from "../../hooks/useLoginLogic";

const LoginModal = ({ onClose }) => {
  // Use our logic hook
  const {
    formData,
    handleInputChange,
    handleSubmit,
    isLoading,
    isDisabled,
    showPassword,
    togglePasswordVisibility,
    captcha,
    captchaInput,
    setCaptchaInput,
    generateCaptchaCode,
    validationError,
    captchaValidationError,
  } = useLoginLogic();

  // --- NEW: Wrapper function to handle submit and close modal ---
  const handleModalSubmit = (e) => {
    // Pass 'onClose' as the second argument (the onSuccess callback)
    handleSubmit(e, onClose);
  };

  return (
    <>
      <NotificationContainer />
      {isLoading && <SkyLoader />}

      <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
        <div className="relative w-full h-full md:max-w-md md:h-[90vh] md:rounded-xl md:overflow-hidden bg-[#ffb600] shadow-2xl">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-[1000] text-black bg-white/50 rounded-full p-2 hover:bg-white transition"
          >
            <FaTimes size={20} />
          </button>

          <div
            className="w-full h-full overflow-auto [&::-webkit-scrollbar]:hidden"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            <div
              className="relative w-full h-[280px] flex flex-col items-center justify-center pt-10 bg-no-repeat bg-center bg-cover"
              style={{ backgroundImage: "url('/images/KV-pic.png')" }}
            >
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                <img
                  src="/logos/logo.png"
                  alt="Skyexch Logo"
                  className="w-24 h-24"
                />
              </div>
            </div>

            <div className="w-full relative -mt-[50px] px-2 flex items-center justify-center pb-10">
              <div className="w-[90%] md:w-[80%] bg-transparent">
                {/* UPDATE: Use handleModalSubmit here */}
                <form
                  method="post"
                  onSubmit={handleModalSubmit}
                  autoComplete="off"
                  noValidate
                  className="w-full"
                >
                  {validationError && (
                    <div className="mb-3 text-sm text-red-700 bg-white/50 p-1 rounded text-center font-bold">
                      {validationError}
                    </div>
                  )}

                  <div className="mb-3">
                    <input
                      value={formData.user_name}
                      onChange={handleInputChange}
                      type="text"
                      name="user_name"
                      placeholder="Username"
                      className="w-full p-1 h-[37px] rounded-md border-2 border-transparent focus:border-black focus:outline-none placeholder-gray-400 text-sx pl-3"
                    />
                  </div>

                  <div className="mb-3">
                    <div className="relative">
                      <input
                        value={formData.password}
                        onChange={handleInputChange}
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        className="w-full p-1 h-[37px] rounded-md border-2 border-transparent focus:border-black focus:outline-none placeholder-gray-400 text-sx pl-3"
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-black text-[18px]"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  <div className="relative w-full mb-3">
                    <input
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                      type="text"
                      maxLength={4}
                      placeholder="Validation Code"
                      className="
                            w-full p-1 h-[37px] pr-28 rounded-md
                            border-2 border-transparent
                            focus:outline-none
                            focus:border-none
                            focus:bg-[#fff0ca]
                            focus:text-[#1e1e1e]
                            focus:shadow-[inset_0_0.2666666667vw_1.3333333333vw_rgba(161,128,45,0.6)]
                            placeholder-gray-400 text-sx pl-3
                        "
                    />

                    <span
                      className="absolute right-1 top-1/2 transform -translate-y-1/2 text-black font-bold text-xl tracking-widest select-none bg-white p-1 rounded-md px-3 cursor-pointer"
                      onClick={generateCaptchaCode}
                    >
                      {captcha}
                    </span>
                  </div>
                  {captchaValidationError && (
                    <span className="text-red-700 font-bold text-sm mb-3 block text-center bg-white/50 rounded">
                      {captchaValidationError}
                    </span>
                  )}

                  <div className="mb-3">
                    <button
                      type="submit"
                      disabled={isDisabled}
                      className="w-full h-[40px] rounded-md text-sm font-bold text-[#ffb600] bg-gradient-to-t from-[#070707] to-[#474747] shadow-lg"
                    >
                      Login
                    </button>
                  </div>
                </form>

                <div className="flex flex-col gap-3 mt-4">
                  <div className="w-full h-11 bg-[rgba(255,255,255,.6)] rounded-md flex items-center justify-center cursor-pointer hover:bg-white/80 transition">
                    <span className="text-[rgba(0,0,0,.7)] text-base font-medium">
                      Customer support
                    </span>
                  </div>
                </div>
                <div className="h-10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LoginModal;
